export enum MIXPANEL_EVENT {
  LOGIN = 'User Logs In',
  SIGN_UP = 'User Signs Up',
  LOG_OUT = 'User Signs Out',
  IMAGE_UPLOAD = 'User Uploads Image',
  IMAGE_DOWNLOAD = 'User Downloads Image',
}
